// src/routes/CompanyRoutes.jsx

import React from "react";
import { Route } from "react-router-dom";

import AboutUs from "../components/Company/AboutUs";
import Team from "../components/Company/Team";
import Careers from "../components/Company/Careers";
import VisionMission from "../components/Company/VisionMission";
import FounderJourney from "../components/Company/FounderJourney";
import ContactUs from "../components/Company/ContactUs";

const companyRoutes = [
  <Route key="about" path="/about-us" element={<AboutUs />} />,
  //<Route key="team" path="/team" element={<Team />} />,
  <Route key="careers" path="/careers" element={<Careers />} />,
  // <Route key="vision" path="/vision-mission" element={<VisionMission />} />,
  <Route key="founder" path="/founderjourney" element={<FounderJourney />} />,
  <Route key="contact" path="/contact" element={<ContactUs />} />, // ✅ lowercase path
];

export default companyRoutes;
